import React from 'react'
import { HelpDrawerWithAccordion } from '@labrav/common'
import { productDetailsImages } from '../../../common/utils/productCreationUtil'
import {
  FaqQuestion,
  FlyoutProductCreationFaqSection,
  HelpDrawerFaqItems,
} from '../FlyoutProductFormHelpFaqs/ProductCreationFaqUtil'
import { CarouselWithModal } from '../../../common/components/CarouselWithModal/CarouselWithModal'

const faqItems: HelpDrawerFaqItems[] = [
  {
    question: (
      <FaqQuestion
        section={FlyoutProductCreationFaqSection.PRODUCT_DETAILS_REFUND_POLICY}
        question="I don’t have a refund policy. What should I add?"
      />
    ),
    answer: (
      <div>
        A refund policy is <strong>required</strong> for all paid products. Your
        policy should state the terms under which refunds are granted and
        provide contact details for refund requests.
      </div>
    ),
  },
]

interface FlyoutProductDetailsRefundPolicyFaqsProps {
  indexModal: number
  setIndexModal: (index: number) => void
}

export const FlyoutProductDetailsRefundPolicyFaqs: React.FC<
  FlyoutProductDetailsRefundPolicyFaqsProps
> = ({ indexModal, setIndexModal }) => (
  <HelpDrawerWithAccordion
    headerTitle="Help & FAQs - Refund Policy"
    faqItems={faqItems}
    customContent={
      <CarouselWithModal
        carouselData={productDetailsImages}
        setCurrentIndex={setIndexModal}
        currentIndex={indexModal}
      />
    }
  />
)
